export default __webpack_public_path__ + "media/images/features/hida/grid-2-b69a35503d05725b3da640eb41dc1dfc.png";